import type { ReactNode } from 'react';
import { isMobile } from '@/biz/tool';

export function EducationStepLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full min-h-0 w-full flex-col bg-white">
      {children}
    </div>
  );
}

export function EducationStepBody({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="education-step-body"
      className={`min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain pb-6 ${isMobile() ? 'px-4 [&>div:first-child]:pr-10' : 'px-8'}`}
    >
      {children}
    </div>
  );
}

export function EducationStepFooter({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="education-step-footer"
      className={`flex shrink-0 items-center justify-end gap-4 border-t border-[#E8E8EC] bg-white pt-4 ${isMobile() ? 'px-4 pb-[calc(16px+env(safe-area-inset-bottom,0px))] [&_button]:!w-0 [&_button]:!min-w-0 [&_button]:flex-1' : 'px-8 pb-8'}`}
    >
      {children}
    </div>
  );
}
